<div class="d-flex flex-column px-3 pt-3">
    <div class="edit-alert cursor-pointer" (click)="editAlert()" id="edit-alert">
        <span class="popup-text">{{'edp.emarket.popup.alerts.editar' | translate}}</span>
    </div>
    <div class="popup-separator my-2"></div>
    <div class="cursor-pointer" (click)="dialogRef.close(true)" id="delete-alert">
        <span class="popup-text">{{'edp.emarket.popup.alerts.eliminar' | translate}}</span>
    </div>
</div>
